import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IChangeToolButtonProps extends IconButtonProps {
    tooltip?: string;
}

export const ChangeToolButton = (props: IChangeToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.Change}
        icon={<ChangeCircleIcon />}
    />
);
